/**
 * Build-time switches for the in-app staging integration suites: the page at
 * /admin/integration-test, which `npm run test:integration:staging`
 * (scripts/run-staging-integration-tests.mjs) builds, serves and opens.
 *
 * `vite build` bakes both values in, and the deployed build sets neither, so
 * there CAN_RUN_STAGING_TESTS has to come out as the constant `false`: App.tsx
 * depends on that to leave the page's route and chunk out of it. Keep
 * STAGING_TESTS_ENABLED a plain comparison of the raw value. Rollup cannot
 * evaluate `.trim()` or `.toLowerCase()`, so normalising it the way the target
 * is normalised puts the page back into the deployed build, and nothing fails.
 */
export const STAGING_TESTS_ENABLED =
  import.meta.env.VITE_ENABLE_STAGING_INTEGRATION_TESTS === "true";

export const STAGING_TEST_TARGET = String(
  import.meta.env.VITE_INTEGRATION_TEST_ENV || "",
)
  .trim()
  .toLowerCase();

export const CAN_RUN_STAGING_TESTS =
  STAGING_TESTS_ENABLED && STAGING_TEST_TARGET === "staging";
